import React, { useEffect } from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import ym, { YMInitializer } from "react-yandex-metrika"

const SEO = ({ lang, meta, title, avatar }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            fio
            author
            jobTitle
          }
        }
      }
    `
  )

  const metaDescription = site.siteMetadata.jobTitle
  const pageTitle =
    title || `${site.siteMetadata.fio} | ${site.siteMetadata.jobTitle}`

  useEffect(() => {
    ym("hit", "/")

    // if (!JSON.parse(localStorage.getItem("ikebot"))) {
    //   fetch("https://worldtimeapi.org/api/ip")
    //     .then(data => data.json())
    //     .then(res => {
    //       fetch(
    //         `https://ikebastuz.pw/cguest.php?timezone=${res.timezone}&client_ip=${res.client_ip}`
    //       )
    //     })
    // }
  }, [])

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang,
        }}
        title={pageTitle}
        meta={[
          {
            name: `description`,
            content: metaDescription,
          },
          {
            property: `og:title`,
            content: pageTitle,
          },
          {
            property: `og:description`,
            content: metaDescription,
          },
          {
            property: `og:type`,
            content: `website`,
          },
          {
            name: `twitter:card`,
            content: `summary`,
          },
          {
            name: `twitter:creator`,
            content: site.siteMetadata.author,
          },
          {
            name: `twitter:title`,
            content: pageTitle,
          },
          {
            name: `twitter:description`,
            content: metaDescription,
          },
          {
            name: "image",
            content: avatar.src,
          },
          {
            name: "og:image",
            content: avatar.src,
          },
          {
            name: "twitter:image",
            content: avatar.src,
          },
          {
            name: "yandex-verification",
            content: "b87ad88246d32f48",
          },
        ].concat(meta)}
      />
      <YMInitializer
        accounts={[62151130]}
        options={{ webvisor: true, defer: true }}
        version="2"
      />
    </>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  jobTitle: ``,
}

SEO.propTypes = {
  jobTitle: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
}

export default SEO
